import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AboutModalComponent } from './about-modal.component';


export class AboutModalModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  declarations: [AboutModalComponent],
  exports: [AboutModalComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
